module.exports = __webpack_public_path__ + "img/img7.7762e377.png";